<h1 mat-dialog-title>{{ currentSection.name + ' - ' + getDownloadtitle() }}</h1>

<mat-dialog-content>
  <form [formGroup]="docDocumentFormGroup">
    <div class="dialog-section-title">
      {{ 'docDocuments.sections.evidence' | transloco }}
    </div>

    <mat-form-field class="input-field" subscriptSizing="dynamic">
      <mat-label class="label-large">
        {{ 'docDocuments.name' | transloco }}
      </mat-label>

      <input #name matInput formControlName="name" autocomplete="off" type="text" [ngClass]="{ 'is-invalid': formControls.name.errors }" />

      <mat-error *ngIf="formControls.name.hasError('required')">
        {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
      </mat-error>

      <mat-error *ngIf="formControls.name.hasError('pattern')">
        {{ 'dataManagement.userData.userDialog.validation.pattern' | transloco }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="input-field" *ngIf="currentSection.possibleEvidenceTypes.length > 1" subscriptSizing="dynamic">
      <mat-label>
        {{ 'docDocuments.evidences' | transloco }}
      </mat-label>

      <mat-select formControlName="linkedEvidences" (selectionChange)="updateControls()" multiple [ngClass]="{ 'is-invalid': formControls.linkedEvidences.errors }">
        <mat-option *ngFor="let evidenceId of currentSection.possibleEvidenceTypes" [value]="possibleEvidences.get(evidenceId)?.id">
          {{ possibleEvidences.get(evidenceId)?.name }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="formControls.linkedEvidences.hasError('required')">
        {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
      </mat-error>
    </mat-form-field>

    <ng-container *ngIf="docDocumentFormGroup.value.linkedEvidences.length > 0">
      @for (evidence of docDocumentFormGroup.value.linkedEvidences; track evidence) {
        <ng-container *ngIf="possibleEvidences.get(evidence)?.unit">
          <mat-form-field class="rowInput" subscriptSizing="dynamic">
            <mat-label class="label-large">
              {{ possibleEvidences.get(evidence)?.name }}
            </mat-label>

            <input matInput type="number" [formControlName]="prefix_result + evidence" />

            <span matSuffix>
              {{ possibleEvidences.get(evidence)?.unit }}
            </span>
          </mat-form-field>

          <mat-form-field class="rowInput" subscriptSizing="dynamic">
            <mat-label>
              {{ 'docDocuments.startDate' | transloco }}
            </mat-label>

            <input matInput autocomplete="off" [matDatepicker]="dpStart" [formControlName]="prefix_start + evidence" />

            <mat-datepicker-toggle matSuffix [for]="dpStart"> </mat-datepicker-toggle>

            <mat-datepicker #dpStart startView="multi-year"> </mat-datepicker>

            <mat-error *ngIf="formControls[prefix_start + evidence].errors">
              <span *ngIf="formControls[prefix_start + evidence].errors?.endBeforeStart">
                {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="rowInput" subscriptSizing="dynamic">
            <mat-label>
              {{ 'docDocuments.endDate' | transloco }}
            </mat-label>

            <input matInput autocomplete="off" [matDatepicker]="dpEnd" [formControlName]="prefix_end + evidence" />

            <mat-datepicker-toggle matSuffix [for]="dpEnd"> </mat-datepicker-toggle>

            <mat-datepicker #dpEnd startView="multi-year"> </mat-datepicker>

            <mat-error *ngIf="formControls[prefix_end + evidence].errors">
              <span *ngIf="formControls[prefix_end + evidence].errors?.endBeforeStart">
                {{ 'dataEvaluation.performEvaluations.errors.endBeforeStart' | transloco }}
              </span>
            </mat-error>
          </mat-form-field>
        </ng-container>
      }
    </ng-container>

    <div class="method-section-header">
      <span class="dialog-section-title">
        {{ 'docDocuments.sections.methodology' | transloco }}
      </span>

      <span>
        {{
          'docDocuments.evidenceMethods.selectedCount'
            | transloco
              : {
                  selected: selectedEvidenceMethods.length,
                  total: evidenceMethods.length,
                }
        }}
      </span>
    </div>

    <div class="evidence-methods">
      <div class="evidence-method" *ngFor="let method of evidenceMethods" [class.selected]="isEvidenceMethodSelected(method.id)">
        <mat-checkbox [checked]="isEvidenceMethodSelected(method.id)" (change)="toggleEvidenceMethod(method.id, $event.checked)">
          {{ method.name }}
        </mat-checkbox>

        <ng-container *ngIf="isEvidenceMethodSelected(method.id)">
          <div class="method-hint">
            {{ getEvidenceMethodHintKey(method.id) | transloco }}
          </div>

          <mat-form-field class="text-area-height-unset" appearance="outline" subscriptSizing="dynamic">
            <mat-label>
              {{ 'docDocuments.description' | transloco }}
            </mat-label>

            <textarea matInput class="no-resize-textarea" rows="5" [formControlName]="prefix_methodDescription + method.id"> </textarea>

            <mat-error *ngIf="formControls[prefix_methodDescription + method.id]?.hasError('required')">
              {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <mat-error class="method-error" *ngIf="formControls.selectedEvidenceMethods.touched && formControls.selectedEvidenceMethods.hasError('required')">
      {{ 'dataManagement.userData.userDialog.validation.atLeastOneSelectionRequired' | transloco }}
    </mat-error>

    <div class="dialog-section-title">
      {{ 'docDocuments.sections.commentAndDocument' | transloco }}
    </div>

    <mat-form-field class="text-area-height-unset" appearance="outline" subscriptSizing="dynamic">
      <mat-label>
        {{ 'docDocuments.comment' | transloco }}
      </mat-label>

      <textarea class="no-resize-textarea" matInput formControlName="comment" maxlength="250" rows="4"> </textarea>
    </mat-form-field>

    <input type="file" accept=".pdf" (change)="onUploadDocClick(hiddenFileInput.files)" #hiddenFileInput onclick="value=null" style="display: none" />

    <div class="upload-row">
      <button *ngIf="!isEditMode" mat-raised-button (click)="hiddenFileInput.click()" color="primary" class="custom-button-top" type="button">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'docDocuments.uploadFile' | transloco }}
      </button>
      <span *ngIf="file || isEditMode" class="selected-file-name">
        <mat-icon>description</mat-icon>
        {{ file ? file.name : document.name }}
      </span>
    </div>
  </form>
</mat-dialog-content>

<div class="dialog-footer" [formGroup]="docDocumentFormGroup">
  <div class="td-export-option">
    <mat-slide-toggle formControlName="ppwrRelevant">
      {{ 'docDocuments.showInPpwrReports' | transloco }}
    </mat-slide-toggle>
  </div>

  <mat-dialog-actions>
    <button (click)="doAction()" [disabled]="!enableSave" mat-raised-button type="submit" color="primary">
      {{ (isEditMode ? 'common.buttons.apply' : 'common.buttons.add') | transloco }}
    </button>

    <button (click)="closeDialog()" mat-raised-button type="button">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
